(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["02-rc-homec-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__rcHeroInit) return; root.__rcHeroInit = true;
      var slides = root.querySelectorAll('.hc-hero__slide');
      if(slides.length < 2) return;
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function(){
        i = (i + 1) % slides.length;
        slides.forEach(function(s, x){ s.classList.toggle('is-active', x === i); });
      }, 6500);
    }
    function run(scope){ (scope || document).querySelectorAll('[data-hc-hero]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["03-rc-homec-capsules"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__hcScroll) return; root.__hcScroll = true;
      var track = root.querySelector('[data-hc-track]');
      if(!track) return;
      function step(dir){
        var card = track.firstElementChild;
        var w = card ? card.offsetWidth + 24 : 360;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var prev = root.querySelector('[data-hc-prev]');
      var next = root.querySelector('[data-hc-next]');
      if(prev) prev.addEventListener('click', function(){ step(-1); });
      if(next) next.addEventListener('click', function(){ step(1); });
    }
    function run(scope){ (scope || document).querySelectorAll('[data-hc-scroller]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["03-rc-partner-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__jnInit) return; root.__jnInit = true;
      var slides = root.querySelectorAll('.jn-quote__slide');
      var dots = root.querySelectorAll('.jn-quote__dot');
      if(slides.length < 2) return;
      var i = 0, timer;
      function show(n){
        i = n;
        slides.forEach(function(s,x){ s.classList.toggle('is-active', x===n); s.setAttribute('aria-hidden', x!==n ? 'true':'false'); });
        dots.forEach(function(d,x){ d.classList.toggle('is-active', x===n); });
      }
      function next(){ show((i+1) % slides.length); }
      function reset(){ clearInterval(timer); timer = setInterval(next, 6500); }
      dots.forEach(function(d,x){ d.addEventListener('click', function(){ show(x); reset(); }); });
      reset();
    }
    function run(scope){ (scope || document).querySelectorAll('[data-jn-quote]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["03-rc-who-founders"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(frame){
      if(frame.__rcVid) return; frame.__rcVid = true;
      function activate(){
        var src = frame.getAttribute('data-video-src');
        if(!src || frame.classList.contains('is-playing')) return;
        var v = document.createElement('video');
        v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
        frame.innerHTML = ''; frame.appendChild(v); frame.classList.add('is-playing');
        frame.removeAttribute('role'); frame.removeAttribute('tabindex');
      }
      frame.addEventListener('click', activate);
      frame.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(); } });
    }
    function run(scope){ (scope || document).querySelectorAll('[data-ww-video]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["04-rc-homec-shop"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__hcShop) return; root.__hcShop = true;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hc-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hc-panel]'));
      function visibleTrack(){
        for(var i = 0; i < panels.length; i++){
          if(!panels[i].hasAttribute('hidden')){
            return panels[i].querySelector('[data-hc-track]') || panels[i];
          }
        }
        return root.querySelector('[data-hc-track]');
      }
      function activate(idx){
        var target = null;
        panels.forEach(function(p){
          if(p.getAttribute('data-hc-panel') === idx){ target = p; }
        });
        if(!target) return;
        tabs.forEach(function(t){
          t.setAttribute('data-active', t.getAttribute('data-hc-tab') === idx ? 'true' : 'false');
        });
        panels.forEach(function(p){
          if(p === target){ p.removeAttribute('hidden'); }
          else { p.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function(t){
        t.addEventListener('click', function(e){
          e.preventDefault();
          if(t.disabled) return;
          activate(t.getAttribute('data-hc-tab'));
        });
      });
      function step(dir){
        var track = visibleTrack();
        if(!track) return;
        var card = track.firstElementChild;
        var w = card ? card.offsetWidth + 24 : 300;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var prev = root.querySelector('[data-hc-prev]');
      var next = root.querySelector('[data-hc-next]');
      if(prev) prev.addEventListener('click', function(){ step(-1); });
      if(next) next.addEventListener('click', function(){ step(1); });
    }
    function run(scope){ (scope || document).querySelectorAll('[data-hc-shop]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });

    /* "show only after quiz results": stays hidden until the shade quiz
       broadcasts rc:quizResults; hides again on start over. */
    function gated(){ return Array.prototype.slice.call(document.querySelectorAll('[data-hc-quiz-reveal]')); }
    function revealAll(){ gated().forEach(function(s){ s.removeAttribute('hidden'); }); }
    function concealAll(){ gated().forEach(function(s){ s.setAttribute('hidden', ''); }); }
    document.addEventListener('rc:quizResults', revealAll);
    document.addEventListener('rc:quizReset', concealAll);
    document.addEventListener('rc:resultsHidden', concealAll);
    if(window.rcShadeMatchResult) revealAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["07-rc-advocate-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__jaInit) return; root.__jaInit = true;
      var slides = root.querySelectorAll('.ja-quote__slide');
      var dots = root.querySelectorAll('.ja-quote__dot');
      if(slides.length < 2) return;
      var i = 0, timer;
      function show(n){
        i = n;
        slides.forEach(function(s,x){ s.classList.toggle('is-active', x===n); s.setAttribute('aria-hidden', x!==n ? 'true':'false'); });
        dots.forEach(function(d,x){ d.classList.toggle('is-active', x===n); });
      }
      function next(){ show((i+1) % slides.length); }
      function reset(){ clearInterval(timer); timer = setInterval(next, 6500); }
      dots.forEach(function(d,x){ d.addEventListener('click', function(){ show(x); reset(); }); });
      reset();
    }
    function run(scope){ (scope || document).querySelectorAll('[data-ja-quote]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["08-rc-advocate-apply"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__jaApplyInit) return; root.__jaApplyInit = true;
      var first = root.querySelector('[data-ja-first]');
      var email = root.querySelector('[data-ja-email]');
      var consent = root.querySelector('[data-ja-consent]');
      var submit = root.querySelector('[data-ja-submit]');
      if(!first || !email || !consent || !submit) return;
      function update(){
        var valid = first.value.trim() !== '' && email.value.trim() !== '' && consent.checked;
        submit.disabled = !valid;
      }
      [first, email].forEach(function(el){ el.addEventListener('input', update); });
      consent.addEventListener('change', update);
      update();
    }
    function run(scope){ (scope || document).querySelectorAll('[data-ja-apply]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["08-rc-homec-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.__hcQuote) return; root.__hcQuote = true;
      var slides = root.querySelectorAll('.hc-quote__slide');
      var dots = root.querySelectorAll('.hc-quote__dot');
      if(slides.length < 2) return;
      var i = 0, timer;
      function show(n){
        i = n;
        slides.forEach(function(s,x){ s.classList.toggle('is-active', x===n); s.setAttribute('aria-hidden', x!==n ? 'true':'false'); });
        dots.forEach(function(d,x){ d.classList.toggle('is-active', x===n); });
      }
      function next(){ show((i+1) % slides.length); }
      function reset(){ clearInterval(timer); timer = setInterval(next, 6500); }
      dots.forEach(function(d,x){ d.addEventListener('click', function(){ show(x); reset(); }); });
      reset();
    }
    function run(scope){ (scope || document).querySelectorAll('[data-hc-quote]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["10-rc-homec-video"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(frame){
      if(frame.__rcVid) return; frame.__rcVid = true;
      function activate(){
        var src = frame.getAttribute('data-video-src');
        var link = frame.getAttribute('data-video-link');
        if(src){
          if(frame.classList.contains('is-playing')) return;
          var v = document.createElement('video');
          v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
          frame.innerHTML = ''; frame.appendChild(v); frame.classList.add('is-playing');
          frame.removeAttribute('role'); frame.removeAttribute('tabindex');
        } else if(link){
          window.location.href = link;
        }
      }
      frame.addEventListener('click', activate);
      frame.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(); } });
    }
    function run(scope){ (scope || document).querySelectorAll('[data-hc-video]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["11-rc-homec-duo"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(frame){
      if(frame.__rcVid) return; frame.__rcVid = true;
      function activate(){
        var src = frame.getAttribute('data-video-src');
        if(!src || frame.classList.contains('is-playing')) return;
        var v = document.createElement('video');
        v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
        frame.innerHTML = ''; frame.appendChild(v); frame.classList.add('is-playing');
        frame.removeAttribute('role'); frame.removeAttribute('tabindex');
      }
      frame.addEventListener('click', activate);
      frame.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(); } });
    }
    function run(scope){ (scope || document).querySelectorAll('[data-hc-video]').forEach(init); }
    if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
